module.exports = __webpack_public_path__ + "img/full6-min.d05b35fd.png";